import { v1 as uuidv1 } from 'uuid';

export default function generateUUID() {
  return uuidv1();
}
